/**
 * P6.1 — Central guard to prevent drawing shortcuts from hijacking
 * typing in inputs, textareas, contenteditables or IME composition.
 * Used by DrawingLayer, useWidgetDrawings and shortcutMap.
 *
 * S1.2/D-02 contract: raw keyboardAdapter handlers receive keydown+keyup;
 * single-fire handlers MUST guard `e.type === "keydown"` first.
 */
export function isTypingTarget(event) {
    // IME composition active — never hijack.
    if (event.isComposing)
        return true;
    const target = event.target;
    if (!target)
        return false;
    const tag = target.tagName;
    if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT")
        return true;
    if (target.isContentEditable)
        return true;
    // Shadow/portal cases: closest() covers ancestor contenteditable / textbox.
    // 2026-10-12: Monaco with the EditContext API types into a plain DIV
    // (.monaco-editor .native-edit-context) — never INPUT/TEXTAREA — so every
    // global letter shortcut (symbol-search quick entry, drawing tool keys)
    // hijacked Pine keystrokes. The .monaco-editor ancestor covers it.
    if (typeof target.closest === "function") {
        if (target.closest(".monaco-editor, [contenteditable], [role='textbox'], input, textarea, select")) {
            // Already handled INPUT/TEXTAREA/SELECT above, but keep for nested cases.
            // For direct INPUT etc. this also returns true (idempotent).
            return true;
        }
    }
    return false;
}
